"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _line = _interopRequireDefault(require("./line"));

var _tag = _interopRequireWildcard(require("./tag"));

var _paragraph = _interopRequireDefault(require("./paragraph"));

var _utilities = require("../utilities");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
 * Represents a song in a chord sheet. Currently a chord sheet can only have one song.
 */


var Song = /*#__PURE__*/function () {
  function Song() {
    var metaData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Song);
    /**
     * The {@link Line} items of which the song consists
     * @member
     * @type {Array<Line>}
     */


    this.lines = [];
    /**
     * The {@link Paragraph} items of which the song consists
     * @member
     * @type {Array<Line>}
     */

    this.paragraphs = [];
    this.currentLine = null;
    this.currentParagraph = null;
    this.assignMetaData(metaData);
  }

  _createClass(Song, [{
    key: "assignMetaData",
    value: function assignMetaData(metaData) {
      var _this = this;

      this.rawMetaData = {};
      Object.keys(metaData).forEach(function (key) {
        _this.setMetaData(key, metaData[key]);
      });
    }
    /**
     * Returns the song lines, skipping the leading empty lines (empty as in not rendering any content). This is useful
     * if you want to skip the "header lines": the lines that only contain meta data.
     * @returns {Array<Line>} The song body lines
     */

  }, {
    key: "chords",
    value: function chords(chr) {
      this.currentLine.chords(chr);
    }
  }, {
    key: "lyrics",
    value: function lyrics(chr) {
      this.ensureLine();
      this.currentLine.lyrics(chr);
    }
  }, {
    key: "addLine",
    value: function addLine() {
      this.ensureParagraph();
      this.flushLine();
      this.currentLine = (0, _utilities.pushNew)(this.lines, _line["default"]);
      return this.currentLine;
    }
  }, {
    key: "setCurrentLineType",
    value: function setCurrentLineType(type) {
      if (this.currentLine) {
        this.currentLine.type = type;
      }
    }
  }, {
    key: "flushLine",
    value: function flushLine() {
      if (this.currentLine !== null) {
        if (this.currentLine.isEmpty()) {
          this.addParagraph();
        } else if (this.currentLine.hasRenderableItems()) {
          this.currentParagraph.addLine(this.currentLine);
        }
      }
    }
  }, {
    key: "finish",
    value: function finish() {
      this.flushLine();
    }
  }, {
    key: "addChordLyricsPair",
    value: function addChordLyricsPair() {
      this.ensureLine();
      return this.currentLine.addChordLyricsPair();
    }
  }, {
    key: "ensureLine",
    value: function ensureLine() {
      if (this.currentLine === null) {
        this.addLine();
      }
    }
  }, {
    key: "addParagraph",
    value: function addParagraph() {
      this.currentParagraph = (0, _utilities.pushNew)(this.paragraphs, _paragraph["default"]);
      return this.currentParagraph;
    }
  }, {
    key: "ensureParagraph",
    value: function ensureParagraph() {
      if (this.currentParagraph === null) {
        this.addParagraph();
      }
    }
  }, {
    key: "addTag",
    value: function addTag(tagContents) {
      var tag = _tag["default"].parse(tagContents);

      if (tag.isMetaTag()) {
        this.setMetaData(tag.name, tag.value);
      }

      this.ensureLine();
      this.currentLine.addTag(tag);
      return tag;
    }
    /**
     * Returns a deep clone of the song
     * @returns {Song} The cloned song
     */

  }, {
    key: "clone",
    value: function clone() {
      var clonedSong = new Song();
      clonedSong.lines = this.lines.map(function (line) {
        return line.clone();
      });
      clonedSong.rawMetaData = _objectSpread({}, this.rawMetaData);
      return clonedSong;
    }
  }, {
    key: "setMetaData",
    value: function setMetaData(name, value) {
      this.optimizedMetaData = null;

      if (!(name in this.rawMetaData)) {
        this.rawMetaData[name] = new Set();
      }

      this.rawMetaData[name].add(value);
    }
    /**
     * Returns the song metadata. When there is only one value for an entry, the value is a string. Else, the value is
     * an array containing all unique values for the entry.
     * @returns {object} The metadata
     */

  }, {
    key: "getOptimizedMetaData",
    value: function getOptimizedMetaData() {
      var _this2 = this;

      var optimizedMetaData = {};
      Object.keys(this.rawMetaData).forEach(function (key) {
        var valueSet = _this2.rawMetaData[key];
        optimizedMetaData[key] = _this2.optimizeMetaDataValue(valueSet);
      });
      return optimizedMetaData;
    }
  }, {
    key: "optimizeMetaDataValue",
    value: function optimizeMetaDataValue(valueSet) {
      if (valueSet === undefined) {
        return null;
      }

      var values = _toConsumableArray(valueSet);

      if (values.length === 1) {
        return values[0];
      }

      return values;
    }
  }, {
    key: "getMetaData",
    value: function getMetaData(name) {
      return this.metaData[name] || null;
    }
  }, {
    key: "previousLine",
    get: function get() {
      var count = this.lines.length;

      if (count >= 2) {
        return this.lines[count - 2];
      }

      return null;
    }
  }, {
    key: "bodyLines",
    get: function get() {
      if (this._bodyLines === undefined) {
        this._bodyLines = _toConsumableArray(this.lines);

        while (!this._bodyLines[0].hasRenderableItems()) {
          this._bodyLines.shift();
        }
      }

      return this._bodyLines;
    }
  }, {
    key: "metaData",
    get: function get() {
      if (!this.optimizedMetaData) {
        this.optimizedMetaData = this.getOptimizedMetaData();
      }

      return this.optimizedMetaData;
    }
  }]);

  return Song;
}();

var defineProperty = Object.defineProperty;
var songPrototype = Song.prototype;

_tag.META_TAGS.forEach(function (tagName) {
  defineProperty(songPrototype, tagName, {
    get: function get() {
      return this.getMetaData(tagName);
    }
  });
});

var _default = Song;
exports["default"] = _default;